import { ServiceAddressCard } from "@/services/backend/addresses/components/service-address-card";
import { useState } from "react";
import {
  UpdateCustomerAddressRequest,
  UpdateServiceAddressRequest,
  useRltContractUpdateCustomerAddressMutation,
  useRltContractUpdateServiceAddressMutation,
} from "@/services/backend/rlt/contracts/api/contract-api";
import { Contract } from "@/services/backend/rlt/contracts/types/contract";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { CustomerAddressCard } from "@/services/backend/addresses/components/customer-address-card";
import t from "@/lang/lang";

export function ContractAddresses({ contract }: { contract: Contract }) {
  return (
    <div className="grid gap-2 lg:grid-cols-2">
      <CustomerAddress contract={contract} />
      <ServiceAddress contract={contract} />
    </div>
  );
}

function ServiceAddress({ contract }: { contract: Contract }) {
  const [request, setRequest] = useState<UpdateServiceAddressRequest>({
    id: contract.id,
    serviceAddress: contract.serviceAddress,
  });
  const mutation = useRltContractUpdateServiceAddressMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: contract.id,
    serviceAddress: contract.serviceAddress,
  });

  return (
    <ServiceAddressCard
      address={request.serviceAddress}
      onAddressChange={(serviceAddress) =>
        setRequest({ ...request, serviceAddress })
      }
      disabled={contract.immutable}
    />
  );
}

function CustomerAddress({ contract }: { contract: Contract }) {
  const [request, setRequest] = useState<UpdateCustomerAddressRequest>({
    id: contract.id,
    customerAddress: contract.customerAddress,
  });
  const mutation = useRltContractUpdateCustomerAddressMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: contract.id,
    customerAddress: contract.customerAddress,
  });

  return (
    <CustomerAddressCard
      customerAddress={request.customerAddress}
      onCustomerAddressChange={(customerAddress) =>
        setRequest({ ...request, customerAddress })
      }
      description={t(
        "Die Adresse des Unternehmens mit welchem der Vertrag geschlossen wird.",
      )}
      disabled={contract.immutable}
    />
  );
}
